import { TranslateService } from '@ngx-translate/core';
import { Component, OnInit, OnDestroy } from "@angular/core";
import { UntypedFormBuilder, UntypedFormGroup } from "@angular/forms";
import { DataProvider } from "projects/packcert-web/src/app/providers/data.provider";
import { Message, SpinnerService, UtilsService } from 'shared-components';
import { GestionContextService } from "../../context/getion-context.service";
import { GestionService } from "../../services/gestion.service";
import { SessionContextService } from 'projects/packcert-web/src/app/context/session-context.service';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';


@Component({
    selector: 'app-mantenimiento-denominaciones',
    templateUrl: './mantenimiento-denominaciones.component.html'
})
export class MantenimientoDenominacionesComponent implements OnInit, OnDestroy {

    private readonly _DEFAULT_ITEMS_PER_PAGE = 10;

    private _filters;
    public filtersVisible = false;
    public filtersForm: UntypedFormGroup;
    public dropdownInfo: number;

    public denominaciones;

    public mensajes = new Array<Message>();
    public showError: boolean;
    public showErrorWarning: boolean;

    public deleteModal = false;
    public newEditModal = false;
    public imageColorModal = false;

    public itemsPerPage = this._DEFAULT_ITEMS_PER_PAGE;
    public currentPage = 0;
    public totalItems: number;
    public readonly visiblePages = 3;

    public toEditId;
    public toEditDes;
    public toDeleteId;

    public dropdownSection: number;
    public pestanaActiva = new Array<number>();

    public orderBy: string;
    public columnId: number;

    private readonly destroy$ = new Subject<void>();

    constructor(
        private _fb: UntypedFormBuilder,
        private readonly _spinnerService: SpinnerService,
        private readonly _sessionContext: SessionContextService,
        private readonly _gestionContext: GestionContextService,
        private readonly _gestionService: GestionService,
        private readonly _dataProvider: DataProvider,
        private readonly utilsService: UtilsService,
        private readonly _translate: TranslateService
    ) {}

    ngOnInit() {
        this.filtersForm = this._fb.group({
            des: [''],
            productoId: [''],
            pais: [''],
            fechaInicio: [''],
            fechaFin: [''],
            dateType: ['false']
        });

        this._gestionContext.mantenimientoDenominacionesFilters = null;

        this.getDenominaciones();

        this.filtersForm.get('fechaInicio').valueChanges.pipe(takeUntil(this.destroy$)).subscribe(() => this.validDates());
        this.filtersForm.get('fechaFin').valueChanges.pipe(takeUntil(this.destroy$)).subscribe(() => this.validDates());
    }

    ngOnDestroy(): void {
        this.destroy$.next();
        this.destroy$.complete();
    }

    public get role() {
        return this._sessionContext.sessionUser.role;
    }

    public get paises() {
        if (this._dataProvider.paises) {
            if (this._dataProvider.paises.length === 1 && this.filtersForm.get('pais').enabled) {
              this.filtersForm.get('pais').patchValue(this._dataProvider.paises[0]);
              this.filtersForm.get('pais').disable();
            }
          }
        return this._dataProvider.paises;
    }

    public get productos() {
        return this._dataProvider.productos;
    }

    public get defaultLanguage() {
      return this._translate.getDefaultLang();
    }

    public get isSmallScreen(){
      return this._sessionContext.isSmallScreen();
    }

    public validDates() {
        if (this.filtersForm.get('fechaInicio').value && this.filtersForm.get('fechaFin').value) {
          if (this.checkDates(this.filtersForm.get('fechaInicio').value, this.filtersForm.get('fechaFin').value)) {
            this.clearDatesValidators();
          } else {
            this.filtersForm.get('fechaInicio').setErrors(['Invalid date']);
            this.filtersForm.get('fechaFin').setErrors(['Invalid date']);
          }
          if (this.filtersForm.get('fechaInicio').invalid || this.filtersForm.get('fechaFin').invalid) {
            this.showError = true;
            this.mensajes.push({ class: 'error', message: 'global.fecha.error.finAnteriorInicio' });
          } else {
            this.showError = false;
            this.mensajes = [];
          }
        } else {
          this.clearDatesValidators();
          this.showError = false;
          this.mensajes = [];
        }
    }

    private clearDatesValidators() {
        if (this.filtersForm.get('fechaFin').errors && this.filtersForm.get('fechaFin').errors.includes('Invalid date')) {
          this.filtersForm.get('fechaFin').clearValidators();
          this.filtersForm.get('fechaFin').updateValueAndValidity();
        }
        if (this.filtersForm.get('fechaInicio').errors && this.filtersForm.get('fechaInicio').errors.includes('Invalid date')) {
          this.filtersForm.get('fechaInicio').clearValidators();
          this.filtersForm.get('fechaInicio').updateValueAndValidity();
        }
    }

    private checkDates(inicio, fin) {
        const inicioD = new Date(inicio);
        const finD = new Date(fin);
        return inicioD <= finD;
    }

    public pageChange(page) {
        this.dropdownInfo = -1;
        this.dropdownSection = -1;
        this._gestionContext.mantenimientoDenominacionesFilters.numPagina = this.currentPage = page - 1;
        this.getDenominaciones();
    }

    public itemsPerPageChange(items) {
        this.dropdownInfo = -1;
        this.dropdownSection = -1;
        this._gestionContext.mantenimientoDenominacionesFilters.numPagina = this.currentPage = 0;
        this._gestionContext.mantenimientoDenominacionesFilters.tamPagina = this.itemsPerPage = items;
        this.getDenominaciones();
    }

    public checkValuesForm(): boolean {
        return (this.filtersForm.get('des').value ||
                this.filtersForm.get('productoId').value ||
                (this.filtersForm.get('pais').value && this.filtersForm.get('pais').enabled) ||
                this.filtersForm.get('fechaInicio').value ||
                this.filtersForm.get('fechaFin').value) ? true : false;
    }

    public filtrar() {
        this.validDates();
        if (this.filtersForm.valid) {
            this.applyFilters();
        }
    }

    public resetForm() {
        this.filtersForm.reset({
            pais: this.filtersForm.get('pais').disabled ? this.filtersForm.get('pais').value : null,
            dateType: 'false'
        });
        //this.filtersForm.get('dateType').patchValue('false');
    }

    public applyFilters() {
        this.currentPage = 0;
        this._gestionContext.mantenimientoDenominacionesFilters = {
            des: this.filtersForm.get('des').value ? this.filtersForm.get('des').value : '',
            paisId: this.filtersForm.get('pais').value ? this.filtersForm.get('pais').value.id : '',
            productoId: this.filtersForm.get('productoId').value ? this.filtersForm.get('productoId').value.id : '',
            fechaInicio: this.filtersForm.get('fechaInicio').value ?
                this.utilsService.parseGMTtoYYYYMMDD(this.filtersForm.get('fechaInicio').value) : '',
            fechaFin: this.filtersForm.get('fechaFin').value ?
                this.utilsService.parseGMTtoYYYYMMDD(this.filtersForm.get('fechaFin').value) : '',
            fechaActualizacion: this.filtersForm.get('dateType').value,
            checkMarcasAsociadas: true,
            cargaRegistroEnUso: true,
            numPagina: this.currentPage,
            tamPagina: this.itemsPerPage
        };
        this.getDenominaciones();
    }

    public getDenominaciones() {
        if (this._gestionContext.mantenimientoDenominacionesFilters) {
            this._filters = this._gestionContext.mantenimientoDenominacionesFilters;
        } else {
            this.applyFilters();
        }
        this._spinnerService.showSpinner();
        this._gestionService.getDenominaciones(this._filters).toPromise().finally(() => {
            this._spinnerService.hideSpinner();
        }).then((resp) => {
            this.totalItems = resp.paginacionMeta.totalCount;
            this.denominaciones = resp.lista;
        }, (error) => {
            this.pushMessage('global.error.noResponse');
        });
    }

    public create() {
        this.toEditId = null;
        this.newEditModal = true;
    }

    public update(denominacion) {
        this.toEditId = denominacion.id;
        this.newEditModal = true;
    }

    public delete() {
        this._spinnerService.showSpinner();
        this._gestionService.deleteDenominacion(this.toDeleteId).toPromise().finally(() => {
            this._spinnerService.hideSpinner();
        }).then(() => {
            this.close();
            this.pushMessage('global.success.itemDeleted');   
            this.getDenominaciones();
        });
    }

    public askDelete(denominacion) {
        this.toDeleteId = denominacion.id;
        this.deleteModal = true;
    }

    public close() {
        this.deleteModal = false;
        this.newEditModal = false;
    }

    public openImageColorModal(denoId: number, des: string) {
        this.toEditId = denoId;
        this.toEditDes = des;
        this.imageColorModal = true;
    }

    public closeImageColorModal() {
        this.imageColorModal = false;
    }

    public refresh(value) {
        this.newEditModal = false;
        if (value) {
            this.getDenominaciones();
        }
    }

    public pushMessage(mensaje) {
        this.showError = true;
        if (mensaje.includes('.error.') || mensaje.includes('existe') || mensaje.includes('ApiErrors')) {
            this.mensajes.push({ class: 'error', message: mensaje });
        } else {
            this.mensajes.push({ class: 'success', message: mensaje });
        }
    }

    public showSection(i, id) {
        this.toEditId = id;
        this.dropdownSection = this.dropdownSection === i ? -1 : i;
        this.pestanaActiva[i] = this.pestanaActiva[i] > 0 ? this.pestanaActiva[i] : 1;
        // Desplazamiento a la izquierda para tablet (mismo tamaño máx. que en table.scss)
        if (this.dropdownSection !== -1 && window.innerWidth <= 1199) {
          // Retardo: en caso de que haya otro detalle abierto
          setTimeout(() => {
            document.querySelector('table')?.scrollIntoView({behavior: 'smooth', block: 'nearest', inline: 'start'});
          }, 50);
        }
    }

    public showDetails(i: number) {
      this.dropdownInfo = this.dropdownInfo === i ? -1 : i;
      if (this.dropdownInfo !== -1 && window.innerWidth <= 1199) {
        setTimeout(() => {
          document.querySelector('table')?.scrollIntoView({behavior: 'smooth', block: 'nearest', inline: 'start'});
        }, 50);
      }
    }

    public changeActiveTab(i: number, tab: number) {
        this.pestanaActiva[i] = tab;
    }

    public getIcon(prop: string, idColumn: number) {
      let iconClass = 'fa fa-sort';
      if (this._filters && this._filters.orderItems && this._filters.orderItems[0].orderProperty.indexOf(prop) != -1 && this.columnId === idColumn) {
          iconClass = this._filters.orderItems[0].orderByDescending === true ? 'fa fa-sort-down' : 'fa fa-sort-up';
      }
      return iconClass;
    }
    public toOrderBy(columnFilter, idColumn) {
        this.columnId = idColumn;
        if (this.denominaciones && this.denominaciones.length > 0) {
          if (this._gestionContext.mantenimientoDenominacionesFilters) {
            this._filters = this._gestionContext.mantenimientoDenominacionesFilters;
            if (!this.orderBy || this.orderBy.includes('DESC')) {
              this.orderBy = 'ASC' + idColumn;
              this._filters.orderItems = [
                {
                  orderProperty: columnFilter,
                  orderByDescending: false
                }
              ];
            } else if (this.orderBy.includes('ASC')) {
              this.orderBy = 'DESC' + idColumn;
              this._filters.orderItems = [
                {
                  orderProperty: columnFilter,
                  orderByDescending: true
                }
              ];
            }
            this.getDenominaciones();
          }
        }
      }

    public trackByDenominacionId(index: number, denominacion: { id: number }): number {
      return denominacion.id;
    }
}
